'use strict';

var BonnetModule = require('./modules/BonnetModule.js');



exports.BonnetModule = BonnetModule.BonnetModule;
exports.Module = BonnetModule.BonnetModule;
